module.exports = "eraser"